import React, { Component } from 'react';
import { Link, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import Autorizacao from '../../security/Autorizacao';
import {
  PERFIL_ADMIN
} from '../../security/securityContext';
import Titulo from '../comum/Titulo';

import PeopleAltOutlinedIcon from '@mui/icons-material/PeopleAltOutlined';

export class MenuUsuario extends Component {
  render () {
    return (
      <div className="area-home">
        <Titulo texto="Usuários" urlRetorno="/"/>
        <div className="row sistemas justify-content-md-center mt-5">
          <Autorizacao perfisPermitidos={[PERFIL_ADMIN]}>
            <div className="col-6 col-sm-6 col-md-3 mt-3">
              <Link to="/painel-usuarios-sistema">
                <div className="card card-inicial ">
                    <div className="card card-inicial-interno ">
                      <i className="material-icons custom-icons"><PeopleAltOutlinedIcon className='css-icon' /></i>
                      <h5 className='nm-longo-resize'>
                        Usuários
                        (Gerencial)
                      </h5>
                    </div>
                </div>
              </Link>
            </div>
          </Autorizacao>
          <Autorizacao perfisPermitidos={[PERFIL_ADMIN]}>
            <div className="col-6 col-sm-6 col-md-3 mt-3">
              <Link to="/painel-usuarios-sites">
                <div className="card card-inicial ">
                    <div className="card card-inicial-interno ">
                      <i className="material-icons custom-icons"><PeopleAltOutlinedIcon className='css-icon' /></i>
                      <h5 className='nm-longo'>
                        Usuários
                        (Plataformas)
                      </h5>
                    </div>
                </div>
              </Link>
            </div>
          </Autorizacao>
          <Autorizacao perfisPermitidos={[PERFIL_ADMIN]}>
            <div className="col-6 col-sm-6 col-md-3 mt-3">
              <Link to="/painel-usuarios-agencia">
                <div className="card card-inicial ">
                    <div className="card card-inicial-interno ">
                      <i className="material-icons custom-icons"><PeopleAltOutlinedIcon className='css-icon' /></i>
                      <h5 className='nm-longo-resize'>
                        Usuários
                        (Agência)
                      </h5>
                    </div>
                </div>
              </Link>
            </div>
          </Autorizacao>
        </div>
      </div>
    );
  }
}
export function mapStateToProps (state) {
  return {
    empresaSelecionada: state.empresaSelecionada,
    authentication: state.authentication
  }
}



export default withRouter(connect(mapStateToProps, {})(MenuUsuario));
